import React, { useEffect, useState } from 'react';

import './App.css';
import SearchBar from './SearchBar';
import VideoList from './VideoList';
import VideoDetail from './VideoDetail';
import CategoryList from './CategoryList';
import ScrollToTop from "react-scroll-to-top";

import daehan_api from '../apis/daehan_api';
//import InfiniteScroll from 'react-infinite-scroll-component';

//const _ = require("lodash");
import loading from './loading.png';

function App() {
  const [state, setState] = useState({
    keyword: '',
    videos: [],
    selectedVideo: null,
    categoryList: [],
    selectedCategory: null,
    categoryListInitialized: false,
    videosInitialized: false,
    page: 1,
    isLastPage: false,
    categoryChanged: true,
    totalRows: 0,
    perPage: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  //const [page, setPage] = useState(1);

  const onInputSubmit = async (keyword, category, page1) => {
    //console.log('onInputSubmit: page: ' + page1);

    // if(state.totalRows > 0 && state.perPage > 0 &&
    //   state.totalRows > (Math.max(page1 - 1, 0) * state.perPage))
    // {
    //   console.log('onInputSubmit: last_page -> return; ');
    //   return;
    // }
    setIsLoading(true);
    setError(null);

    try {
      const response = await daehan_api.get('/daehanvodlist', {
        params: {
          keyword: keyword,
          category: category,
          page: page1,
        }
      });

      const youtube_list = response.data;
      const { page, offset, per_page, total_rows, items } = youtube_list;
      //const category2 = (keyword == null || keyword === '') ? category : null;
      const keyword2 = (category == null || category === '') ? keyword : null;
      const videos2 = items; // _.shuffle(items);

      //setPage(prevPage => prevPage + 1);

      //console.log(items);

      page1 = page;

      let isLastPage = (offset + per_page >= total_rows);
      let categoryChanged = state.categoryChanged || (keyword != null && keyword != '');
      //console.log('categoryChanged', categoryChanged);

      if (isLastPage && page1 > 1) {
        //alert('마지막 페이지입니다');
        console.log('last page');

      } else {
        let nextState = {
          ...state,
          keyword: keyword2,
          videos: categoryChanged ? videos2 : state.videos.concat(videos2),
          videosInitialized: true,
          categoryChanged: false,
          page: page1 + 1,
          totalRows: total_rows,
          perPage: per_page,
          isLastPage
        };

        if (page1 == 1)
          nextState['selectedVideo'] = items && items.length > 0 ? videos2[0] : null;

        setState(nextState);

        //console.log('aster setstate: ', state.categoryChanged)
      }

    } catch (error) {
      setError(error);

    } finally {
      //console.log('set isLoading false')
      setIsLoading(false);
    }
  };

  const updateCategory = async () => {
    //console.log('updateCategory');

    setIsLoading(true);
    setError(null);

    try {

      const response = await daehan_api.get('/daehanvodlist/category_list', {
        params: {
        }
      });

      const category_list = response.data;
      const { items } = category_list;
      const category_list2 = items.map((item) => { return item.category; });

      setState({
        ...state,
        categoryList: category_list2,
        categoryListInitialized: true,
        categoryChanged: true,
      });

    } catch (error) {
      setError(error);

    } finally {
      //console.log('set isLoading false')
      setIsLoading(false);
    }
  };

  var ranonce = false;
  useEffect(() => {
    if (!ranonce) {
      updateCategory();
      ranonce = true;
    }
  }, []);

  useEffect(() => {
    if (state.categoryListInitialized) {
      onInputSubmit(state.keyword, state.selectedCategory);
    }
  }, [state.categoryListInitialized, state.selectedCategory])

  const onSelectVideo = (video) => {
    setState({ ...state, selectedVideo: video })

    scrollToVideo();
  }

  const onSelectCategory = (cat) => {
    //console.log('onSelectCategory', cat)
    setState({ ...state, keyword: null, selectedCategory: cat, categoryChanged: true });

    //onInputSubmit(state.keyword, state.selectedCategory);
  }

  const onMoreVideo = () => {
    onInputSubmit(state.keyword, state.selectedCategory, state.page);
  };

  // const hasMorePage = () => {
  //   return state.offset + state.per_page >= state.total_rows;
  // };

  const handleScroll = () => {
    //console.log('handleScroll!');

    let root = document.getElementById('root');
    if (window.innerHeight + Math.round(window.scrollY) < root.offsetHeight || isLoading) {
      return;
    }

    onMoreVideo();
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isLoading]);

  const scrollToVideo = () => {
    let searchBarTop = document.getElementById('searchBar')
    // .offsetTop;
    // let videoDetailTop = document.getElementById('videoDetail').offsetTop;
    // if (Math.round(window.scrollY) > videoDetailTop) {
    //   window.scrollTo({
    //     top: searchBarTop,
    //     behavior: 'smooth'
    //   });
    // }
    searchBarTop.scrollIntoView({behavior: 'smooth'});
  }

  return (
    <>
      { isLoading ? <img className='loading' src={loading} /> : <div />}
      <ScrollToTop smooth color="#6f00ff" />
      <div className="ui container" style={{ marginTop: '20px' }}>
        <div className="ui grid">
          <div className="three wide computer sixteen wide mobile column stackable grid" style={{ marginBottom: '40px' }}>
            <div className="ui images">
              <a href="https://www.daehansarang.org/">
                <img className="ui image" src="https://www.daehansarang.org/views/_layout/modena/img/home/logo_ko4.png" />
              </a>
            </div>
            <div style={{ marginTop: '20px' }}>
              <CategoryList
                categoryList={state.categoryList}
                selectedCategory={state.selectedCategory}
                onSelectCategory={onSelectCategory} />
            </div>
          </div>
          <div className="thirteen wide computer sixteen wide mobile column stackable ">
            <SearchBar keyword={state.keyword} onSubmit={onInputSubmit} />
            <div className="ui grid">
              <div className="eleven wide computer sixteen wide mobile column ">
                <div id='videoDetail'>
                  <VideoDetail video={state.selectedVideo} />
                </div>
              </div>
              <div className="five wide computer sixteen wide mobile column">
                <VideoList onSelectVideo={onSelectVideo}
                  videos={state.videos} selectedVideo={state.selectedVideo}
                  onMoreVideo={onMoreVideo} isLastPage={state.isLastPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
